var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.34834,0,0,1.34834,-139.335,-139.336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.596,177.02L582.604,629.127C580.39,639.801 567.873,644.638 559.042,638.221L430.734,545.067C422.945,539.411 412.324,539.712 404.867,545.792L333.728,603.78C325.473,610.532 313.032,606.769 309.871,596.601L260.475,437.742L132.856,390.113C119.893,385.257 119.782,366.956 132.709,361.976L656.457,159.928C667.56,155.634 679.015,165.361 676.596,177.02ZM551.327,258.776L301.913,412.389C292.353,418.287 287.854,429.832 290.938,440.64L317.904,535.393C319.822,542.106 329.563,541.421 330.497,534.484L337.505,482.523C338.829,472.74 343.494,463.722 350.731,456.99L556.566,265.655C560.42,262.085 555.807,256.025 551.327,258.776Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7aee1230e4939c4c0dfc065775fe712e.svg";
export { ForwardRef as ReactComponent };